//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getClosestComponent } from "../../../assets/js/utils/commons";

export default {
  name: "S2TableCustomizable",
  components: {
    TableCustomizableBody: () => import("./TableCustomizableBody.vue"),
    TableCustomizableFooter: () => import("./TableCustomizableFooter.vue"),
    TableCustomizableHeader: () => import("./TableCustomizableHeader.vue"),
    TableCustomizableSelectors: () =>
      import("./TableCustomizableSelectors.vue"),
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    main: {
      type: String,
      required: true,
    },
    multiple: {
      type: Object,
      default: () => ({}),
    },
    paginator: {
      default: undefined,
      validator: (paginator) =>
        paginator instanceof Object || paginator === undefined,
    },
    rows: {
      type: Array,
      required: true,
    },
    sizes: {
      type: Array,
      required: true,
    },
    sort: {
      default: undefined,
      validator: (sort) => sort instanceof Object || sort === undefined,
    },
  },
  data() {
    return {
      position: {
        height: 0,
        left: 0,
        top: 0,
        width: 0,
      },
    };
  },
  computed: {
    selectedCount() {
      return this.multiple.selections?.length || 0;
    },
    selectors() {
      return this.rows.map((row) => row.id);
    },
  },
  created() {
    this.$options.IS_SUBTABLE = !!getClosestComponent(
      this.$parent,
      this.$options.name
    );
  },
  methods: {
    emitAction(data) {
      this.$emit("table-action", data);
    },
    emitPage(data) {
      this.$emit("table-page", data);
    },
    emitSelection(selections) {
      this.$emit("table-selection", { selections });
    },
    emitSize(data) {
      this.$emit("table-size", data);
    },
    emitSort(data) {
      this.$emit("table-sort", data);
    },
    setPositionScroll(ev) {
      this.position.left = -ev.target.scrollLeft;
      this.position.top = -ev.target.scrollTop;
    },
    setPositionSize() {
      const el = this.$refs["table-content"];
      if (el) {
        this.position.height = el.clientHeight;
        this.position.width = el.clientWidth;
      }
    },
  },
};
